import script from "./RutinaHero.vue?vue&type=script&setup=true&lang=js"
export * from "./RutinaHero.vue?vue&type=script&setup=true&lang=js"

import "./RutinaHero.vue?vue&type=style&index=0&id=0875062a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0875062a"]])

export default __exports__